export const LIST_ITEM_SPACING_PX = 20;

export const LIST_GUTTER_VALUES_PX: Record<string, number> = {
  small: 10,
  large: 15,
};
